<template>
  <GmapMarker
    ref="marker"
    :position="position"
    :clickable="true"
    @click="clicked"
  >
    <GmapInfoWindow
      v-if="opened"
      ref="window"
      :opened="opened"
    >

      <PostPreview :post="post"/>

    </GmapInfoWindow>
  </GmapMarker>
</template>

<script>
import PostPreview from "./PostPreview";

export default {
  name: "PostMarker",
  components: {
    PostPreview
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      opened: false
    };
  },
  computed: {
    position() {
      return { lat: this.post.geo.lat, lng: this.post.geo.lon };
    },
    date() {
      return new Date(this.post.date).toString();
    }
  },
  methods: {
    clicked() {
      this.opened = !this.opened;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PostMarker.vue